import {
	TypedUseSelectorHook,
	useDispatch,
	useSelector
} from 'react-redux';

import type { AppDispatch, IMapFeatureUIState } from './store';

// Use throughout the mfui app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;

export const useAppSelector: TypedUseSelectorHook<IMapFeatureUIState> = useSelector;
